import { useDispatch, useSelector } from "react-redux";
import makePayload from "../components/Cart/AddToCart/make-payload";
import { addToCart } from "../lib/redux/slices/cart-slice";

export const useUpdateCart = () => {
  const storeData = useSelector((s) => s);
  const dispatch = useDispatch();

  function updateCart(cb) {
    if (typeof cb !== "function") {
      throw new Error("Callback must be a function");
    }

    const payload = cb(storeData);
    const formattedData = makePayload(payload);
    dispatch(addToCart(formattedData));
  }

  return {
    updateCart,
  };
};
